import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import UpgradePlanModal from '../billing/UpgradePlanModal';

export default function AdminTile({
  title,
  description,
  icon: Icon,
  iconColor,
  iconBg,
  to,
  locked,
  lockedPlan,
  comingSoon,
  badge,
  currentPlan,
  onUpgraded,
}) {
  const navigate = useNavigate();
  const [showUpgrade, setShowUpgrade] = useState(false);

  const handleClick = () => {
    if (comingSoon) return;
    if (locked) {
      setShowUpgrade(true);
      return;
    }
    if (to) navigate(to);
  };

  return (
    <>
      <div
        onClick={handleClick}
        className={`relative bg-white rounded-xl border border-gray-200 p-5 transition-all ${
          comingSoon
            ? 'opacity-50 cursor-not-allowed'
            : locked
            ? 'hover:border-amber-300 hover:shadow-md cursor-pointer'
            : 'hover:border-brand-300 hover:shadow-md cursor-pointer'
        }`}
      >
        {/* Lock icon for paid features */}
        {locked && !comingSoon && (
          <div className="absolute top-3 right-3">
            <Lock className="h-4 w-4 text-amber-500" />
          </div>
        )}

        <div className="flex items-start justify-between mb-3">
          <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${iconColor} ${iconBg}`}>
            <Icon className="h-5 w-5" />
          </div>
          <div className="flex items-center gap-1.5">
            {badge && (
              <span className="text-xs px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 font-medium">
                {badge}
              </span>
            )}
            {comingSoon ? (
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-500">
                Coming Soon
              </span>
            ) : locked ? (
              <span className="text-xs px-2 py-1 rounded-full bg-amber-50 text-amber-700">
                {lockedPlan}+
              </span>
            ) : (
              <span className="text-xs px-2 py-1 rounded-full bg-green-50 text-green-700">
                Ready
              </span>
            )}
          </div>
        </div>

        <h3 className="text-sm font-semibold text-gray-900 mb-1">{title}</h3>
        <p className="text-xs text-gray-500 leading-relaxed">{description}</p>

        {!comingSoon && !locked && (
          <div className="mt-3 flex items-center gap-1 text-xs font-medium text-brand-600">
            Open <ArrowRight className="h-3 w-3" />
          </div>
        )}
        {locked && !comingSoon && (
          <div className="mt-3 flex items-center gap-1 text-xs font-medium text-amber-600">
            Upgrade to unlock <ArrowRight className="h-3 w-3" />
          </div>
        )}
      </div>

      {locked && (
        <UpgradePlanModal
          isOpen={showUpgrade}
          onClose={() => setShowUpgrade(false)}
          currentPlan={currentPlan}
          onUpgraded={onUpgraded}
          message={`This feature requires the ${lockedPlan} plan or higher. Upgrade now to unlock it.`}
        />
      )}
    </>
  );
}
